import classNames from "classnames";
import React from "react";

const RadioDot = ({ isSelected }) => {
  return (
    <div
      className={classNames("radio-dot", { "radio-dot_selected": isSelected })}
    />
  );
};

export default RadioDot;
